/* tslint:disable */
/* eslint-disable */
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CreateDocumentAcceptanceData
 */
export interface CreateDocumentAcceptanceData {
    /**
     * Who accepted the document. Defaults to the requesting employee.
     * @type {number}
     * @memberof CreateDocumentAcceptanceData
     */
    employeeId?: number;
}

/**
 * Check if a given object implements the CreateDocumentAcceptanceData interface.
 */
export function instanceOfCreateDocumentAcceptanceData(value: object): value is CreateDocumentAcceptanceData {
    return true;
}

export function CreateDocumentAcceptanceDataFromJSON(json: any): CreateDocumentAcceptanceData {
    return CreateDocumentAcceptanceDataFromJSONTyped(json, false);
}

export function CreateDocumentAcceptanceDataFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreateDocumentAcceptanceData {
    if (json == null) {
        return json;
    }
    return {
        
        'employeeId': json['employeeId'] == null ? undefined : json['employeeId'],
    };
}

  export function CreateDocumentAcceptanceDataToJSON(json: any): CreateDocumentAcceptanceData {
      return CreateDocumentAcceptanceDataToJSONTyped(json, false);
  }

  export function CreateDocumentAcceptanceDataToJSONTyped(value?: CreateDocumentAcceptanceData | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'employeeId': value['employeeId'],
    };
}

